import {formColors} from './styles.js'

// Inline styles can't reach pseudo-elements like ::placeholder, so the few rules that need a selector are injected
// once as a <style> element in the head instead of living in a stylesheet. Built from the tokens in styles.ts, which
// stay the only source of the values.

/** Class of the text controls in a FieldBox (<input>, <textarea>), the rules below are scoped to it */
export const fieldControlClass = 'form-field-control'

const styleElementId = 'veloyd-form-field-styles'

// Firefox lowers the placeholder's opacity by default, opacity 1 keeps the token's colour
const css = `.${fieldControlClass}::placeholder { color: ${formColors.placeholder}; opacity: 1; }`

/** Adds the field rules to the document once, safe to call any number of times and without a document (tests, SSR) */
export function ensureFieldStyles() {
    if (typeof document === 'undefined' || document.getElementById(styleElementId)) {
        return
    }

    const style = document.createElement('style')
    style.id = styleElementId
    style.textContent = css
    document.head.appendChild(style)
}
